import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {IconBase} from 'react-icons'

const Methodology = () => {
    return (

        <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
            <div className="container about px-lg-0">
                <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <h4 className="text-primary">SARSYS-CAD is a complex system of strength analysis on the all stages of the structure: </h4>
                    <ul>
                        <li>design, production, certification test, structural strength monitoring and individual life prediction on the operation stage.</li>
                    </ul>
                </div>

                <VerticalTimeline>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                        iconStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 1</h3>
                        <h4 className="vertical-timeline-element-subtitle">Preliminary stage</h4>
                        <p>
                            Determination of realistic input data; parameters of the loading and properties of material by patented KTSM methods. For conversion the parameters of random loading regime into equivalent harmonic regime the original (patented) method (BIS) is developed instead RainFlow. The equivalency is guaranteed.
                        </p>

                        <p><i><b>Note: </b></i>The block regime of the loading determined by standard RainFlow method cannot be equivalent in principle.</p>
                        <img src="img/test_setup.jpg" style={{width:'450px'}}></img>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        iconStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 2</h3>
                        <h4 className="vertical-timeline-element-subtitle">Filling of Strength and Reliability in designing structure</h4>
                        <p>
                            Design, Structural Strength Analysis and Life Prediction stage. SARSYS-CAD is the combination AutoCAD software with Strength and Reliability System (SARSYS) makes design process more efficient: productive without redesigning and optimisation necessary, guaranties accurate results and cost effectiveness.
                        </p>
                        <img src="img/data_setup.jpg" style={{width:'450px'}}/>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        iconStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 3</h3>
                        <h4 className="vertical-timeline-element-subtitle">Virtual measurement of filling completeness</h4>
                        <p>
                            Strength and reliability analysis of the designed structure by SARSYS-CAD. However according SARSYS-CAD procedure Stage 3 is conducted jointly with Stage 2. In this case strength is a key criterion in structural design.
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        iconStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 4</h3>
                        <h4 className="vertical-timeline-element-subtitle">Post-fabrication stage. Practical measurement of the real object filling completeness</h4>
                        <p>
                            Non-destructive Certificating Test (NDCT) and Individual Life Prediction. NDCT is a calibration of the coordinates for measurement of physical characteristics of Strength and Reliability of the new product. NDCT is a bridge between Stages 2, 3 and Stage 5.
                        </p>
                        <img src="img/stage5.jpg" style={{width:'450px'}}/>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--education"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 5</h3>
                        <p>
                            The Comparison the results of virtual strength analysis in Stage 3 and physical results of Stage 4.
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--education"
                        contentStyle={{ background: 'rgb(66,197,116)', color: '#fff' }}
                        iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                        icon={<IconBase />}
                    >
                        <h3 className="vertical-timeline-element-title">STAGE 6</h3>
                        <h4 className="vertical-timeline-element-subtitle">Operation stage.</h4>
                        <h4 className="vertical-timeline-element-subtitle">Practical measurement of the volume of strength and reliability consumption for period operation.</h4>
                        <p>
                            Determination of the Structural Strength and Reliability parameters at any moment of operation under any mode of the loading: harmonic or random thanks to unique (patented) SARSYS-CAD subsystem, an accurate determination of the individual remaining life and prevention of catastrophic situation. This is a key advantage for safety of aircrafts.
                        </p>
                        <p><i><b>Note: </b></i>the nCODE’s “DesignLife” area of application is Fatigue Analysis only. SARSYS-CAD is applicable at all stage of structural life from design to operation.</p>
                        <img src="img/stage6.jpg" style={{width:'450px'}}></img>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                        icon={<IconBase />}
                    />
                </VerticalTimeline>
            </div>
        </div>

    )
}

export default Methodology;